<template>
<a-range-picker
    class='SelectTime'
    :style="customStyle"
    v-model="createTime"
    :format="showTime ? valueFormat : 'YYYY-MM-DD'"
    @change="handleChange"
    @ok="handleOk"
    :showTime="showTime ? { format: timeFormat, defaultValue: showTime ? DEFAULT_TIME[defaultTime] : false } : false"
    :ranges="ranges"
    :disabled='disabled'
    :separator='separator'
    :allow-clear='allowClear'
    :allow-today='allowToday'
    :placeholder="placeholder"
    :disabled-date="disabledDate">
    <template slot="renderExtraFooter">
        <a-button type="primary" ghost size="small" v-if="allowClear" @click="handleClear">清除</a-button>
        <a-button type="primary" ghost size="small" v-if="allowReset" @click="handleReset">重置</a-button>
        <a-button type="primary" ghost size="small" v-if="allowToday" @click="handleChooseToday">今天</a-button>
    </template>
    <template slot="suffixIcon"><i class="icon" :class="suffixIcon"/></template>
</a-range-picker>
</template>

<script>
import Core from '../../core';
import moment from 'moment';

let startOfDay = moment().hour(0).minute(0).seconds(0);
let endOfDay = moment().hour(23).minute(59).seconds(59);

export default {
    model: {
        prop: 'value',
        event: 'update'
    },
    props: {
        value: { type: Object, default: () => ({}) },
        keys: { type: Array, default: () => (['begin_time', 'end_time']) },

        ranges: {},
        disabled: { type: Boolean, default: false },
        showTime: { type: Boolean, default: true },
        separator: { type: String, default: '-' },
        allowClear: { type: Boolean, default: true },
        allowReset: { type: Boolean, default: false }, // 重置日期至默认
        allowToday: { type: Boolean, default: false },
        placeholder: { type: Array, default: () => (['开始时间', '结束时间']) },
        customStyle: { type: [Object,Array,String], default: () => ({}) },

        defaultTime: { type: String, default: 'B_TO_E' },
        suffixIcon: { type: String, default: '' },

        maxDateLen: {}, // 最多可选时长

        disabledDate: {}, // 不可选择日期

        valueFormat: { type: String, default: 'YYYY-MM-DD HH:mm:ss' }, // 日期展示模式
        timeFormat: { type: String, default: 'HH:mm:ss' }, // 时间展示模式
    },
    data() {
        return {
            loading: false,
            DEFAULT_TIME: Core.Const.TIME_PICKER_DEFAULT_VALUE,

            createTime: [],
        };
    },
    watch: {
        value: {
            immediate: true,
            deep: true,
            handler(n) {
                let values = Object.values(n)
                // console.log('values', values);
                if (!n || values.length < this.keys.length || values.some(i => !i)) {
                    this.createTime = []
                } else {
                    let arr = []
                    if (this.timeFormat === 'HH:mm') {
                        for (let i = 0; i < this.keys.length; i++) {
                            arr[i] = moment.unix(n[this.keys[i]]).format('YYYY-MM-DD HH:mm')
                        }
                    } else {
                        for (let i = 0; i < this.keys.length; i++) {
                            arr[i] = moment.unix(n[this.keys[i]]).format('YYYY-MM-DD HH:mm:ss')
                        }
                    }
                    this.createTime = arr
                    console.log('watch arr:', arr)
                }
            }
        }
    },
    methods: {
        handleChange() {
            let obj = {}
            console.log('this.createTime:', this.createTime)
            if (!this.createTime || this.createTime.length < this.keys.length) {
                // 为空时
                for (let i = 0; i < this.keys.length; i++) {
                    obj[this.keys[i]] = undefined
                }
            } else {
                // 有值时
                if (this.showTime) {
                    obj[this.keys[0]] = this.createTime[0] ? moment(this.createTime[0]).unix() || '' : undefined
                    obj[this.keys[1]] = this.createTime[1] ? moment(this.createTime[1]).unix() || '' : undefined
                } else {
                    obj[this.keys[0]] = this.createTime[0] ? moment(this.createTime[0]).startOf('d').unix() || '' : undefined
                    obj[this.keys[1]] = this.createTime[1] ? moment(this.createTime[1])[this.defaultTime === 'B_TO_E' ? 'endOf' : 'startOf']('d').unix() || '' : undefined
                }

                if (this.maxDateLen) {
                    let start = obj[this.keys[0]];
                    let end   = obj[this.keys[1]];
                    if((end - start) > (this.maxDateLen * 24 * 60 * 60)) {
                        this.$message.warning(`时间跨度最长${this.maxDateLen}天`);
                        obj[this.keys[0]] = end - this.maxDateLen * 24 * 60 * 60 + 1
                    }
                }
            }
            console.log('handleTimeChange:', obj)
            this.$emit('update', obj);
            this.$emit('change', obj);
        },
        handleOk() {
            this.$emit('ok');
        },
        handleClear() {
            this.createTime = []
            this.handleChange();
        },
        handleReset() {
            this.$emit('reset');
        },
        handleChooseToday() {
            this.createTime = [
                startOfDay,
                endOfDay
            ]
            this.handleChange();
        },
    },
};
</script>